import { useState, useEffect } from 'react';
import api, { API_BASE } from '../../api';

export default function ExportPanel({ stores }) {
  const [exportFields, setExportFields] = useState([]);
  const [form, setForm] = useState({
    fields: ['phone','full_name','bonus_balance','stores','created_at'],
    store_ids: [],
    only_active: false,
  });

  useEffect(() => {
    api.get('/customers/export/fields').then(r => setExportFields(r.data)).catch(() => {});
  }, []);

  function toggleField(key) {
    setForm(prev => ({
      ...prev,
      fields: prev.fields.includes(key) ? prev.fields.filter(f => f !== key) : [...prev.fields, key]
    }));
  }

  function toggleStore(id) {
    setForm(prev => ({
      ...prev,
      store_ids: prev.store_ids.includes(id) ? prev.store_ids.filter(s => s !== id) : [...prev.store_ids, id]
    }));
  }

  async function doExport() {
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${API_BASE}/customers/export/csv`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({
          fields: form.fields,
          store_ids: form.store_ids.length ? form.store_ids : null,
          only_active: form.only_active,
        }),
      });
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `clients_${new Date().toISOString().slice(0,10)}.csv`;
      a.click();
      URL.revokeObjectURL(url);
    } catch { alert('Помилка експорту'); }
  }

  return (
    <div style={styles.panel}>
      <h3 style={styles.title}>⬇️ Налаштування експорту</h3>
      <div style={styles.grid}>
        <div style={styles.left}>
          <label style={styles.label}>Поля для експорту</label>
          <div style={styles.fieldsGrid}>
            {exportFields.map(f => (
              <label key={f.key} style={styles.fieldChk}>
                <input type="checkbox"
                  checked={form.fields.includes(f.key)}
                  onChange={() => toggleField(f.key)} />
                {f.label}
              </label>
            ))}
          </div>

          <label style={styles.label}>Фільтр по магазинах</label>
          <div style={styles.chips}>
            <div style={{...styles.chip, ...(form.store_ids.length===0 ? styles.chipOn : {})}}
              onClick={() => setForm({...form, store_ids:[]})}>
              🌐 Всі магазини
            </div>
            {stores.map(s => (
              <div key={s.id}
                style={{...styles.chip, ...(form.store_ids.includes(s.id) ? styles.chipOn : {})}}
                onClick={() => toggleStore(s.id)}>
                🏪 {s.name}
              </div>
            ))}
          </div>

          <label style={styles.checkLabel}>
            <input type="checkbox" checked={form.only_active}
              onChange={e => setForm({...form, only_active:e.target.checked})} />
            Тільки активні клієнти
          </label>

          <div style={styles.exportRow}>
            <button style={styles.exportBtn} onClick={doExport}>⬇️ Скачати CSV</button>
            <span style={styles.hint}>Відкривається в Excel / Google Sheets</span>
          </div>
        </div>

        <div style={styles.previewBox}>
          <div style={styles.previewTitle}>Що буде в файлі</div>
          {form.fields.length === 0 ? (
            <p style={styles.previewSub}>Оберіть поля зліва</p>
          ) : (
            <>
              <div style={styles.divider}/>
              {form.fields.map(f => {
                const field = exportFields.find(ef => ef.key === f);
                return <div key={f} style={styles.previewRow}>✓ {field?.label || f}</div>;
              })}
              <div style={styles.divider}/>
              <div style={styles.note}>
                {form.store_ids.length > 0
                  ? `📍 Тільки клієнти з ${form.store_ids.length} магазин(ів)`
                  : '🌐 Клієнти з усіх магазинів'}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

const styles = {
  panel: { background:'#211c14', borderBottom:'1px solid #38301f', padding:'20px 32px' },
  title: { color:'#f5a623', margin:'0 0 16px' },
  grid: { display:'flex', gap:'20px', flexWrap:'wrap' },
  left: { flex:2, minWidth:'280px' },
  label: { display:'block', color:'#9a8a6e', fontSize:'11px', marginBottom:'6px', textTransform:'uppercase', letterSpacing:'0.5px' },
  fieldsGrid: { display:'grid', gridTemplateColumns:'repeat(2, 1fr)', gap:'8px', marginBottom:'16px' },
  fieldChk: { display:'flex', alignItems:'center', gap:'8px', color:'#cbd5e0', fontSize:'13px', cursor:'pointer' },
  chips: { display:'flex', flexWrap:'wrap', gap:'8px', marginBottom:'14px' },
  chip: { padding:'6px 14px', background:'#38301f', color:'#9a8a6e', borderRadius:'20px', cursor:'pointer', fontSize:'13px', border:'1px solid #38301f' },
  chipOn: { background:'#1c1812', color:'#f5a623', border:'1px solid #f5a623' },
  checkLabel: { display:'flex', alignItems:'center', gap:'8px', color:'#9a8a6e', fontSize:'13px', cursor:'pointer', marginBottom:'16px' },
  exportRow: { display:'flex', alignItems:'center', gap:'12px' },
  exportBtn: { padding:'10px 24px', background:'#2d6a4f', color:'#5fbf8f', border:'none', borderRadius:'8px', cursor:'pointer', fontWeight:'bold' },
  hint: { color:'#9a8a6e', fontSize:'12px' },
  previewBox: { flex:1, minWidth:'200px', background:'#1c1812', borderRadius:'10px', padding:'16px' },
  previewTitle: { color:'#f5a623', fontWeight:'bold', fontSize:'14px', marginBottom:'12px' },
  previewSub: { color:'#9a8a6e', fontSize:'13px' },
  divider: { height:'1px', background:'#38301f', margin:'10px 0' },
  previewRow: { fontSize:'13px', color:'#cbd5e0', marginBottom:'4px' },
  note: { color:'#f5a623', fontSize:'12px', lineHeight:'1.5', marginTop:'8px' },
};
